const regExp = /^(?=.*\d)(?=.*[A-ZÄÖÜ])(?=.*[a-z])(?=.*[!@#$%^&*(),.?":{}|<>_+-=~]|\d|[A-Za-zÄÖÜäöü]).{8,}$/;
export default function validatePassword(password) {
  return regExp.test(password);
}
